import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

export function Link({ 
    to, 
    children, 
    className = '', 
    external = false, 
    onClick,
    ...props 
}) {
    const linkProps = {
        href: to,
        className: `link ${className}`,
        onClick,
        ...props
    };

    // Add external link attributes for security
    if (external) {
        linkProps.target = '_blank';
        linkProps.rel = 'noopener noreferrer';
    }

    return (
        <a {...linkProps}>
            {children}
        </a>
    );
}

Link.propTypes = {
    to: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    external: PropTypes.bool,
    onClick: PropTypes.func,
};